<template>
  <v-layout column class="pa-4" justify-center align-center>
    <v-card class="pa-3">
      <v-card-title>Twoja sesja wygasła</v-card-title>
      <v-card-text>Zaloguj się ponownie</v-card-text>
      <v-card-actions class="justify-end"><v-btn dark color="blue" @click="logOut">Zaloguj</v-btn></v-card-actions>
    </v-card>
  </v-layout>
</template>
<script>
export default {
  methods: {
        logOut() {
      this.$store.dispatch('auth/logout');
      this.$router.push('/login');
    }
  },
};
</script>
